import { Column, ColumnType, DeleteRow, Row } from '~components/table-view';

import { AccessTag } from '~support-at-home/actions/accessTags';

export const columnsFactory = (
  tags: AccessTag[],
  onDelete: (row: Row) => void,
  isAdmin: boolean,
  explicitOnly: string[] = [],
  // Permissions admins receive automatically ONLY when they hold unlocking_permissions (e.g. forms
  // Create). They auto-check for unlock-holder admin rows even though `explicitOnly` keeps them off
  // for plain admins. Empty by default → no effect on the supplier-invoices usage.
  unlockOnly: string[] = [],
  // Optional display overrides for column headers, keyed by permission (e.g. { View: 'View/Fill' }).
  // The underlying permission string is unchanged — display only.
  permissionLabels: Record<string, string> = {},
): Column[] => [
  {
    id: 'full_name',
    header: 'Name',
    type: 'text',
  },
  ...tags.map((tag, index) => ({
    id: `${tag.id}-${tag.permission}-${index}`,
    header: permissionLabels[tag.permission] ?? tag.permission,
    type: 'checkbox' as ColumnType,
    width: '120px',
    deriveValue: (row: Row) =>
      row?.tags?.some((t: any) => t.tag_id === tag.id) ||
      (!explicitOnly.includes(tag.permission) && !row.editable) ||
      (unlockOnly.includes(tag.permission) && !row.editable && !!row.unlocking_permissions),
  })),
  {
    id: 'delete-button',
    header: '',
    type: 'custom',
    style: { width: '50px' },
    component: DeleteRow,
    componentProps: {
      onDelete,
      tooltip: 'Remove access tags',
      disabled: (row: Row) => !isAdmin || !row.editable,
    },
  },
];
